export default () => ({
  selectedTv: {},
  statusRequestTvs: undefined,
  specialDevicesCalled: [],
  tvs: [],
  roomNr: "",
  onlyOneTv: false,
  noTv: true,
});
